import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { BaseTexture } from '../textures/BaseTexture.mjs';
import { Framebuffer } from '../framebuffer/Framebuffer.mjs';
import { MSAA_QUALITY, MIPMAP_MODES } from '@pixi/constants';
var BaseRenderTexture = /*#__PURE__*/function (_BaseTexture) {
  _inherits(BaseRenderTexture, _BaseTexture);
  var _super = _createSuper(BaseRenderTexture);
  function BaseRenderTexture() {
    var _options$multisample;
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, BaseRenderTexture);
    if (typeof options === "number") {
      var width = arguments[0];
      var height = arguments[1];
      var scaleMode = arguments[2];
      var resolution = arguments[3];
      options = {
        width: width,
        height: height,
        scaleMode: scaleMode,
        resolution: resolution
      };
    }
    options.width = options.width || 100;
    options.height = options.height || 100;
    (_options$multisample = options.multisample) !== null && _options$multisample !== void 0 ? _options$multisample : options.multisample = MSAA_QUALITY.NONE;
    _this = _super.call(this, null, options);
    _this.mipmap = MIPMAP_MODES.OFF;
    _this.valid = true;
    _this.clearColor = [0, 0, 0, 0];
    _this.framebuffer = new Framebuffer(_this.realWidth, _this.realHeight).addColorTexture(0, _assertThisInitialized(_this));
    _this.framebuffer.multisample = options.multisample;
    _this.maskStack = [];
    _this.filterStack = [{}];
    return _this;
  }
  _createClass(BaseRenderTexture, [{
    key: "resize",
    value: function resize(desiredWidth, desiredHeight) {
      this.framebuffer.resize(desiredWidth * this.resolution, desiredHeight * this.resolution);
      this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.framebuffer.dispose();
      _get(_getPrototypeOf(BaseRenderTexture.prototype), "dispose", this).call(this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(BaseRenderTexture.prototype), "destroy", this).call(this);
      this.framebuffer.destroyDepthTexture();
      this.framebuffer = null;
    }
  }]);
  return BaseRenderTexture;
}(BaseTexture);
export { BaseRenderTexture };